import { render } from "./Data.m.vue?vue&type=template&id=95cbc7ee&scoped=true"
import script from "./Data.m.vue?vue&type=script&lang=js"
export * from "./Data.m.vue?vue&type=script&lang=js"

import "./Data.m.vue?vue&type=style&index=0&id=95cbc7ee&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cbc7ee"]])

export default __exports__